import React, { useState, useEffect, useCallback } from "react";
import Swal from "sweetalert2";
import Select from "react-select";
import { Spinner } from "reactstrap";
import PhoneInput from 'react-phone-input-2';
import { useMatch, useParams, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const AddEditUser = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const isView = !!useMatch("/user/view/:id");
    const isEdit = !!useMatch("/user/edit/:id");
    const isCreate = !id;

    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [password, setPassword] = useState("");
    const [isActive, setIsActive] = useState(false);
    const [isLoginAllow, setIsLoginAllow] = useState(false);
    const [mobileNoError, setMobileNoError] = useState("");
    const [selectedRole, setSelectedRole] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const token = localStorage.getItem('authToken');
    const user = JSON.parse(localStorage.getItem("authUser"));

    const fetchData = useCallback(async () => {
        try {
            const fetchList = async (url) => {
                const res = await fetch(url, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const json = await res.json();
                return json?.recordsets?.[0] || [];
            };

            setRoles(await fetchList("https://api.kunalsdrumclass.com/api/GetActiveRoles"));

        } catch (error) {
            console.error("Fetch error", error);
        }
    }, []);

    const loadDetails = useCallback(async () => {
        if (!id) return;

        try {
            const res = await fetch(`https://api.kunalsdrumclass.com/api/GetUserById?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const json = await res.json();
            const item = json?.recordsets?.[0]?.[0];

            setFirstName(item.FirstName);
            setLastName(item.LastName);
            setMobileNo(item.Mobile_No);
            setEmailAddress(item.Email_Address);
            setPassword(item.Password);
            setSelectedRole(item.Role_Id);
            setIsActive(item.IsActive);
            setIsLoginAllow(item.LoginAllow);

        } catch (err) {
            console.error(err);
        }
    }, [id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        if (id) loadDetails();
    }, [id, loadDetails]);

    const formatIndianNumber = (value) => {
        const num = value.replace(/\D/g, "");
        let formatted = "+91 ";

        if (num.length > 2) {
            const mobile = num.slice(2);
            if (mobile.length <= 5) {
                formatted += mobile;
            } else {
                formatted += mobile.slice(0, 5) + "-" + mobile.slice(5, 10);
            }
        }
        return formatted.trim();
    };

    const handlePhoneChange = (value) => {
        const formatted = formatIndianNumber(value);
        setMobileNo(formatted);

        if (formatted) {
            setMobileNoError("");
        }
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            const payload1 = {
                id: isEdit ? id : 0,
                firstName: firstName,
                lastName: lastName,
                emailAddress: emailAddress,
                password: password,
                mobileNo: mobileNo,
                roleId: selectedRole,
                loginAllow: isLoginAllow,
                userId: user.Id,
                isActive: isActive
            };
            const res1 = await fetch(`https://api.kunalsdrumclass.com/api/InsertUpdateUser`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                body: JSON.stringify(payload1),
            });

            const res1Data = await res1.json();
            const status = res1Data?.recordsets?.[0]?.[0]?.Status;

            if (status === 0) {
                await Swal.fire({
                    title: "Duplicate Record",
                    text: `user record already exists!`,
                    icon: "warning",
                    customClass: {
                        popup: "swal2-material-ui",
                        confirmButton: "btn btn-sm rounded-8 btn-warning",
                    },
                });
                return;
            }

            await Swal.fire({
                title: "Success!",
                text: isEdit ? `user updated successfully!` : `user created successfully!`,
                icon: "success",
                customClass: {
                    popup: "swal2-material-ui",
                    confirmButton: "btn btn-sm rounded-8 btn-primary",
                },
            });

            navigate(-1);
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Something went wrong while saving user", "error");
        } finally {
            setLoading(false);
        }
    };

    const roleOptions = roles
        .filter(role => user?.Role === "Super Admin"
            ? true
            : role.Name !== "Super Admin"
        )
        .map(item => ({
            value: item.Id,
            label: item.Name
        }));

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title="Users"
                    breadcrumbItems={[
                        { title: "Users", link: "/users" },
                        { title: isCreate ? "Add User" : isView ? "View User" : "Edit User" }
                    ]}
                />
            </div>

            <div className="container py-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="mb-0">
                        {isCreate && "Create User"}
                        {isView && "View User"}
                        {isEdit && "Edit User"}
                    </h3>

                    <button
                        className="btn btn-secondary"
                        onClick={() => navigate(-1)}
                    >
                        Back to List
                    </button>
                </div>

                <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
                    {loading ? (
                        <div className="text-center my-4">
                            <Spinner color="primary" />
                        </div>
                    ) : (
                        <>
                            {/* Form */}
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 mb-30">
                                        <div className="form-contact">
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label>First Name*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={firstName}
                                                            disabled={isView}
                                                            onChange={(e) => setFirstName(e.target.value)}
                                                            placeholder="First Name"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label>Last Name*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={lastName}
                                                            disabled={isView}
                                                            onChange={(e) => setLastName(e.target.value)}
                                                            placeholder="Last Name"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group no-phone-label">
                                                        <label>Mobile No*</label>
                                                        <PhoneInput country={'in'} placeholder="Your Mobile No *" disabled={isView} value={mobileNo || ""} inputClass="form-control phone"
                                                            inputStyle={{
                                                                width: "-webkit-fill-available"
                                                            }}
                                                            inputProps={{
                                                                name: "phone",
                                                                required: true
                                                            }}
                                                            onChange={handlePhoneChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label>Email*</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            value={emailAddress}
                                                            disabled={isView}
                                                            onChange={(e) => setEmailAddress(e.target.value.toLowerCase())}
                                                            placeholder="Email"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <div className="form-group">
                                                        <label>Select Role*</label>
                                                        <Select
                                                            value={
                                                                roleOptions.find(
                                                                    option => option.value === selectedRole
                                                                ) || null
                                                            }
                                                            isDisabled={isView}
                                                            onChange={(selectedOption) =>
                                                                setSelectedRole(selectedOption ? selectedOption.value : "")
                                                            }
                                                            required
                                                            isClearable={!isView}
                                                            options={roleOptions}
                                                            classNamePrefix="select2-selection"
                                                            placeholder="Select Role"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-4">
                                                    <label className="form-label">Password*</label>
                                                    <div className="input-group">
                                                        <input
                                                            type={showPassword ? "text" : "password"}
                                                            disabled={isView}
                                                            className="form-control"
                                                            value={password || ""}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            placeholder="Password"
                                                            required
                                                        />
                                                        <span
                                                            className="input-group-text"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => setShowPassword(!showPassword)}
                                                        >
                                                            <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isActive}
                                                        disabled={isView}
                                                        onChange={(e) => setIsActive(e.target.checked)}
                                                    />
                                                    <label className="form-check-label">
                                                        Is Active?
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={isLoginAllow}
                                                        disabled={isView}
                                                        onChange={(e) => setIsLoginAllow(e.target.checked)}
                                                    />
                                                    <label className="form-check-label">
                                                        Is Login Allow?
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Save/Cancel Button */}
                            {!isView && (
                                <div className="mt-3 d-flex gap-2 justify-content-end">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Cancel
                                    </button>

                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {isCreate ? "Save" : "Update"}
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </form>
            </div>
        </div>
    );
};

export default AddEditUser;
